import {Injectable} from "@angular/core";
import {ApiService} from "../api.service";
import {HttpClient} from "@angular/common/http";
import {DataEntityFilter} from "../../filters/data-entity.filter";
import {DataEntity} from "../../../shared/types/models/data-entity.model";

@Injectable({
  providedIn: 'root'
})
export class DataEntityService extends ApiService<DataEntity> {
  public filter = new DataEntityFilter();

  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'dataentity');
  }

  public getFilter(): DataEntityFilter {
    return this.filter;
  }
}
